/* eslint-disable max-len */
/* eslint-disable dot-notation */
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';
import api from '@src/api';

interface GetPersonalPayrollListPayload {
	year?: number;
	task_type: 'payroll' | 'bonus' | 'reissue';
	page?: number;
	page_size?: number;
}
export const getPersonalPayrollList = (payload: GetPersonalPayrollListPayload): Observable<Action> => (
	api.get('payroll-tasks/front-desk', payload)
);

export const getPersonalPayrollDetail = (payload: { id: string }): Observable<Action> => (
	api.get(`payroll-tasks/${payload.id}/front-desk`)
);

export const getPayslipDisplaySettings = (): Observable<Action> => (
	api.get('payroll-tasks/payslip-display-settings')
);

export const getPayrollTaskDisplaySettings = (payload: { id: string }): Observable<Action> => (
	api.get(`payroll-tasks/${payload.id}/display-settings`)
);
